export const getISODateAtUTC = (date: Date) => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split('T')[0];
};

const DateEnGB = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

export const getDateRangeString = (start: string, end: string) => {
  const startDate = DateEnGB.format(new Date(start));
  const endDate = DateEnGB.format(new Date(end));

  return `${startDate} - ${endDate}`;
};
